import { useEffect, useState } from 'react';

import { DEFAULT_DEBOUNCE_MS } from './useDebouncedValue.constants';

export const useDebouncedValue = <T>(value: T, delayMs: number = DEFAULT_DEBOUNCE_MS): T => {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delayMs);

		return () => clearTimeout(timer);
	}, [value, delayMs]);

	return debounced;
};
